// components/utils/ObjektBild.jsx
import "./ObjektBild.css";
import defaultAvatar from "../../assets/coin-avatar.png";

export default function ObjektBild({
    coin,
    activeImage,
    onToggle,
    onDetailClick,
    showDetailButton = false,   // <— Default: Button nicht anzeigen
    showImageMarker = false,     // <- Detault: kein Marker wenn mehr als 1 Bild
    isMobile = false
}) {

  // Prüfen, welche Bilder existieren
  const hasBild01 = Boolean(coin.bild01);
  const hasBild02 = Boolean(coin.bild02);

  // Finales Bild bestimmen
  let finalImageUrl;
  let active;

  // 1. Mobile: activeImage ist ein String
  if (isMobile) {
    active = activeImage || (hasBild01 ? "bild01" : hasBild02 ? "bild02" : "none");
  }

  // 2. Desktop: activeImage ist ein Objekt
  else {
    active = activeImage[coin.id] || (hasBild01 ? "bild01" : hasBild02 ? "bild02" : "none");
  }

  // 3. Final image selection
  if (active === "bild01" && hasBild01) {
    finalImageUrl = coin.bild01;
  } else if (active === "bild02" && hasBild02) {
    finalImageUrl = coin.bild02;
  } else {
    finalImageUrl = defaultAvatar;
  }

  return (
    <div
      className="objektbild-container"
      onClick={(e) => {
        e.stopPropagation();
        onToggle(); // Desktop oder Mobile – Logik kommt vom Parent
      }}
      style={{ position: "relative" }}
    >
      {/* Detail-Button oben rechts */}
      {showDetailButton && (
        <div
          className="objektbild-detail-button"
          onClick={(e) => {
            e.stopPropagation(); // verhindert Toggle
            onDetailClick(coin.id); // öffnet Detailseite
          }}
        >
          ID {coin.id}
        </div>
      )}

      {/* Bild */}
      <img
        src={finalImageUrl}
        alt="Objekt"
        className="objektbild-img"
      />

      {/* Kleiner Marker unten rechts */}
        {showImageMarker && hasBild01 && hasBild02 && (
          <div
            style={{
              position: "absolute",
              bottom: "6px",
              right: "6px",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.8)",
              border: "1px solid rgba(0,0,0,0.3)",
              pointerEvents: "none"
            }}
          />
        )}
    </div>
  );
}
